var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 4.99994L7.46948 10.3667L12.939 4.99994","stroke":"#0A8EFF","stroke-width":"3.22006"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }